import React from "react";
import styled from "styled-components";
import { MySlider } from "../MySlider";

export const ScreenshotSlides: React.FC<{ className?: string }> = (props) => (
  <DeviceFrame className={props.className}>
    <DeviceFrameContent>
      <Slider spaceBetween={0} slidesPerView={1} autoplayDelay={3000} loop>
        {Array.from({ length: 4 }).map((_, i) => (
          <Screenshot
            key={`screenshot-${i}`}
            src={`/insurers/screenshots/${i + 1}.jpg`}
          />
        ))}
      </Slider>
    </DeviceFrameContent>
  </DeviceFrame>
);

const DeviceFrame = styled.div`
  background: url(/insurers/screenshots/frame.png) no-repeat;
  width: 300px;
`;

const DeviceFrameContent = styled.div`
  padding: 18px 12px;
`;

const Slider = styled(MySlider)`
  width: 277px;
  border-radius: 22px 22px 34px 34px;
`;

const Screenshot = styled.img`
  height: 578px;
`;
